export const formatResponseTime = (seconds: number | null) => {
  if (seconds === null) return "—";
  const wholeSeconds = Math.round(seconds);
  const minutes = Math.floor(wholeSeconds / 60);
  const remainingSeconds = wholeSeconds % 60;
  return `${minutes}m ${remainingSeconds}s`;
};

export const formatCount = (value: number | null) => {
  if (value === null) return "—";
  return String(Math.round(value));
};

export const formatRate = (value: number | null) => {
  if (value === null) return "—";
  return `${Math.round(value * 100)}%`;
};

export const formatPercent = (value: number | null) => {
  if (value === null) return "—";
  return `${Math.round(value)}%`;
};

export const formatDecimal = (value: number | null, digits = 1) => {
  if (value === null) return "—";
  return value.toFixed(digits);
};

export const formatTenureMonths = (months: number) => {
  const rounded = Math.round(months);
  if (rounded === 1) return "1 month";
  return `${rounded} months`;
};

export const formatMentorTenure = (days: number, months: number) => {
  if (days >= 1 && days <= 28) {
    return `Week ${Math.ceil(days / 7)}`;
  }
  return formatTenureMonths(months);
};

export const formatTrendChange = ({
  absoluteChange,
  direction,
  format,
}: {
  absoluteChange: number | null;
  direction: "up" | "down" | "unchanged" | "unavailable";
  format: (value: number) => string;
}) => {
  if (direction === "unavailable" || absoluteChange === null) {
    return "—";
  }
  if (direction === "unchanged" || absoluteChange === 0) {
    return "No change";
  }
  return format(Math.abs(absoluteChange));
};
